import { c as _c } from "react/compiler-runtime";
import { useRouter, useSearchParams } from "next/navigation";
import { useRouteStore } from "../stores/data/store";
import { HeaderIconName } from "../types/type/icon";
import { toast } from "../utils/toastMessage";
import { useGetLocale } from "@/shared/hooks/useGetLocale";
const useIconAction = () => {
  const $ = _c(16);
  const router = useRouter();
  const locale = useGetLocale();
  const query = useSearchParams();
  let t0;
  if ($[0] !== query) {
    t0 = query?.get("redirect") || undefined;
    $[0] = query;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const r = t0;
  let t1;
  if ($[2] !== locale || $[3] !== r || $[4] !== router) {
    t1 = () => {
      if (r) {
        router.push(r);
        return;
      }
      useRouteStore.getState().setIsGoingBack(true);
      const prev = useRouteStore.getState().popPath(locale);
      router.push(prev || "/");
    };
    $[2] = locale;
    $[3] = r;
    $[4] = router;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const handleBackRoute = t1;
  let t2;
  if ($[6] !== locale || $[7] !== router) {
    t2 = () => {
      router.push(`/${locale}`);
    };
    $[6] = locale;
    $[7] = router;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const handleHomeRoute = t2;
  const handleShareRoute = _temp;
  let t3;
  if ($[9] !== handleBackRoute || $[10] !== handleHomeRoute) {
    t3 = iconName => {
      const actions = {
        back: handleBackRoute,
        home: handleHomeRoute,
        share: handleShareRoute
      };
      return actions[iconName];
    };
    $[9] = handleBackRoute;
    $[10] = handleHomeRoute;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const getAction = t3;
  let t4;
  if ($[12] !== getAction || $[13] !== handleBackRoute || $[14] !== handleHomeRoute) {
    t4 = {
      handleBackRoute,
      handleHomeRoute,
      handleShareRoute,
      getAction
    };
    $[12] = getAction;
    $[13] = handleBackRoute;
    $[14] = handleHomeRoute;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};
export default useIconAction;
function _temp() {
  navigator.clipboard.writeText(window.location.href);
  toast.success("URL\uC774 \uBCF5\uC0AC\uB418\uC5C8\uC2B5\uB2C8\uB2E4.");
}